import styled from 'styled-components'

export const Container = styled.div`
  padding: 0px 10px;
  background-color: #0a0a0a;
  div:not(:last-child) {
    padding-bottom: 5px;
  }

  @media (min-width: 769px) {
    margin-bottom: 10px;
    padding: 15px;
  }
`

export const WrapperContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  background-color: #0a0a0a;
`

export const NotCarts = styled.div`
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 80%;
  margin: auto;

  img {
    width: 200px;
    height: auto;
    aspect-ratio: attr(width) / attr(height)
  }
  h1 {
    margin: 5px 0px 0px;
    opacity: 0.5;
    color: #FFF;
    text-align: center;
    font-size: 24px;
  }
`

export const Title = styled.h1`
  font-weight: 600;
  font-size: 20px;
  color: #FFF;
  margin-bottom: 8px;
  line-height: 30px;
  margin-top: 0;
  text-align: center;

  @media (min-width: 576px) {
    text-align: left;
  }
`

export const MultiCartPriceContainer = styled.div`
  margin-top: 38px;
  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 5px;
    margin-bottom: 5px;
    > h4 {
      font-size: 18px;
      margin: 0;
    }
  }
  > span {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;
  }
  p {
    font-size: 14px;
    color: #FFF;
    margin: 0;
    opacity: 0.8;
  }
  h4 {
    color: #FFF;
  }
`
